import { useState, useEffect } from "react";
import type { AgentConfig, WidgetConfig } from "../../shared/types";
import { ApiClient } from "../api/client";

interface UseWidgetConfigResult {
  config: AgentConfig | null;
  isLoading: boolean;
  error: string | null;
}

export function useWidgetConfig(
  widgetConfig: WidgetConfig,
): UseWidgetConfigResult {
  const [config, setConfig] = useState<AgentConfig | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const apiClient = new ApiClient(widgetConfig.apiUrl, widgetConfig.agentId);

    apiClient
      .getAgentConfig()
      .then((agentConfig) => {
        setConfig(agentConfig);
        setError(null);
      })
      .catch((err) => {
        console.error("Failed to fetch agent config:", err);
        setError("Failed to load chat configuration. Please try again later.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [widgetConfig.apiUrl, widgetConfig.agentId]);

  return { config, isLoading, error };
}
